"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FatCrossCloseButton = void 0;
// import styled from "styled-components";
const React = __importStar(require("react"));
// const crossColor = "rgb(102, 102, 102)";
/* export const FatCrossCloseButton = styled.span`
  display: block;
  width: 15px;
  height: 15px;
  transform: rotate(45deg);
  opacity: 0.8;

  &:before,
  &:after {
    content: "";
    position: absolute;
    z-index: -1;
    background: ${crossColor};
  }

  &:before {
    left: 55%;
    width: 20%;
    margin-left: -12%;
    height: 100%;
  }

  &:after {
    top: 55%;
    height: 20%;
    margin-top: -17%;
    width: 100%;
    margin-left: -47%;
  }

  &:hover {
    opacity: 1;
  }
`; */
const FatCrossCloseButton = ({ onClick }) => {
    return (React.createElement("svg", { onClick: onClick, width: "15", height: "15", viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("line", { x1: "5", x2: "90", y1: "5", y2: "95", stroke: "#939393", strokeWidth: "20" }),
        React.createElement("line", { x1: "5", x2: "90", y1: "95", y2: "5", stroke: "#939393", strokeWidth: "20" })));
};
exports.FatCrossCloseButton = FatCrossCloseButton;
//# sourceMappingURL=fat-cross-close-button.js.map